module.exports = __webpack_public_path__ + "img/follow-us-5.7836c2f5.jpg";